'use strict';
import Vue from 'vue';
import Checkbox from './components/clientSettings/Checkbox';
import Toggle from './components/clientSettings/Toggle';
import Dropdown from './components/clientSettings/Dropdown';

import ToggleWithLabel from './components/clientSettings/ToggleWithLabel';

import PaymentSecuresBookingToggle from './components/clientSettings/PaymentSecuresBookingToggle';
import AbsorbPaymentsToggle from './components/clientSettings/AbsorbPaymentsToggle';

import App from './components/clientSettings/App';
import ClientHealthCheck from './components/clientSettings/ClientHealthCheck';
import store from './store/clientSettings';

import SalesCalculator from './components/clientSettings/SalesCalculator';
import SalesCalculatorCustomer from './components/clientSettings/SalesCalculatorCustomer';

import ResetSetupFees from './components/clientSettings/ResetSetupFees';
import CreateNewSetupFees from './components/clientSettings/CreateNewSetupFees';
import Sms from './components/clientSettings/Sms';

import PhotoPermission from './components/clientSettings/PhotoPermission';

import ResetClientStripeSubscriptionId from './components/clientSettings/ResetClientStripeSubscriptionId';

const nodes = document.querySelectorAll('.clientSetting');
if (nodes) {
	for (var i = 0; i < nodes.length; i++) {
		new Vue({
			name: 'App',
			el: '.clientSetting',
			template: '<Checkbox />',
			components: {
				Checkbox
			}
		});
	}
}

const dropdownNodes = document.querySelectorAll('.clientDropdownSetting');
if (dropdownNodes) {
	for (var i = 0; i < dropdownNodes.length; i++) {
		new Vue({
			name: 'App',
			el: '.clientDropdownSetting',
			template: '<Dropdown />',
			components: {
				Dropdown
			}
		});
	}
}

const switchNodes = document.querySelectorAll('.clientSettingSwitch');
if (switchNodes) {
	for (var i = 0; i < switchNodes.length; i++) {
		new Vue({
			name: 'App',
			el: '.clientSettingSwitch',
			template: '<Toggle />',
			components: {
				Toggle
			}
		});
	}
}

const switchWithLabelNodes = document.querySelectorAll('.clientSettingSwitchLabel');
if (switchWithLabelNodes) {
	for (var i = 0; i < switchWithLabelNodes.length; i++) {
		new Vue({
			name: 'App',
			el: '.clientSettingSwitchLabel',
			template: '<ToggleWithLabel />',
			components: {
				ToggleWithLabel
			}
		});
	}
}

if (document.getElementById('clientSettings')) {
	new Vue({
		name: 'App',
		el: '#clientSettings',
		template: '<App />',
		store,
		components: {
			App
		}
	});
}

if (document.getElementById('smsSetting')) {
	new Vue({
		name: 'Sms',
		el: '#smsSetting',
		template: '<Sms />',
		store,
		components: {
			Sms
		}
	});
}

if (document.getElementById('healthCheck')) {
	new Vue({
		name: 'ClientHealthCheck',
		el: '#healthCheck',
		template: '<ClientHealthCheck />',
		store,
		components: {
			ClientHealthCheck
		}
	});
}

if (document.getElementById('salesCalculator')) {
	new Vue({
		name: 'SalesCalculator',
		el: '#salesCalculator',
		template: '<SalesCalculator />',
		components: {
			SalesCalculator
		}
	});
}

if (document.getElementById('salesCalculatorCustomer')) {
	new Vue({
		name: 'SalesCalculatorCustomer',
		el: '#salesCalculatorCustomer',
		template: '<SalesCalculatorCustomer />',
		components: {
			SalesCalculatorCustomer
		}
	});
}

if (document.getElementById('resetSetupFees')) {
	new Vue({
		name: 'ResetSetupFees',
		el: '#resetSetupFees',
		template: '<ResetSetupFees />',
		store,
		components: {
			ResetSetupFees
		}
	});
}

if (document.getElementById('createNewSetupFees')) {
	new Vue({
		name: 'CreateNewSetupFees',
		el: '#createNewSetupFees',
		template: '<CreateNewSetupFees />',
		store,
		components: {
			CreateNewSetupFees
		}
	});
}

if (document.getElementById('payment-secures-booking')) {
	new Vue({
		name: 'PaymentSecuresBookingToggle',
		el: '#payment-secures-booking',
		template: '<PaymentSecuresBookingToggle />',
		components: {
			PaymentSecuresBookingToggle
		}
	});
}

if (document.getElementById('absorb-payments')) {
	new Vue({
		name: 'AbsorbPaymentsToggle',
		el: '#absorb-payments',
		template: '<AbsorbPaymentsToggle />',
		components: {
			AbsorbPaymentsToggle
		}
	});
}

if (document.getElementById('photo-permission')) {
	new Vue({
		name: 'PhotoPermission',
		el: '#photo-permission',
		template: '<PhotoPermission />',
		components: {
			PhotoPermission
		}
	});
}


if (document.getElementById('reset-stripe-subscription')) {
	new Vue({
		name: 'ResetStripeSubscription',
		el: '#reset-stripe-subscription',
		store,
		template: '<ResetClientStripeSubscriptionId />',
		components: {
			ResetClientStripeSubscriptionId
		}
	});
}
